import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
/* Constants */
import { PAGE_TYPE_TERMS_OF_SERVICE } from '@constants/pages';
/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import TosPage from '@scenes/TosPage/TosPage';
/* Types */
import { Children } from 'types/base.types';

function TermsOfService(): Children {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Terms and Conditions' })}</Head>
      <TosPage />
    </>
  );
}

TermsOfService.pageAttributes = { page: PAGE_TYPE_TERMS_OF_SERVICE };
TermsOfService.Layout = getLayout({ promo: false, footer: true });

export default TermsOfService;
